import React from "react";
import { Link } from "react-router-dom";

export function Footer({ side = "enterprise" }) {
  const tag = side === "machines" ? "Crowther. Physical AI, on the owner\u2019s terms." : "Crowther. Building the sovereign intelligence stack.";
  return (
    <>
      <footer className="e2-footer" data-testid="e2-footer">
        <div className="e2-footer-inner">
          <div className="brand-line">{tag}</div>
          <div className="e2-footer-cols">
            <div className="e2-footer-col" data-testid="e2-footer-col-enterprise">
              <div className="e2-footer-eyebrow">For People &amp; Enterprises</div>
              <Link to="/enterprise-2" data-testid="e2-footer-enterprise-home">Overview</Link>
              <Link to="/enterprise-2/solution" data-testid="e2-footer-solution">What We Build</Link>
              <Link to="/enterprise-2/about" data-testid="e2-footer-about">About</Link>
              <Link to="/enterprise-2/research" data-testid="e2-footer-research">Research</Link>
              <Link to="/enterprise-2/contact" data-testid="e2-footer-contact">Contact Us</Link>
            </div>
            <div className="e2-footer-col" data-testid="e2-footer-col-machines">
              <div className="e2-footer-eyebrow">For Machines</div>
              <Link to="/machines-2" data-testid="e2-footer-machines-home">Overview</Link>
              <Link to="/machines-2/products" data-testid="e2-footer-machines-products">Products</Link>
              <Link to="/machines-2/industries" data-testid="e2-footer-machines-industries">Industries</Link>
              <Link to="/machines-2/approach" data-testid="e2-footer-machines-approach">Approach</Link>
              <Link to="/machines-2/contact" data-testid="e2-footer-machines-contact">Talk to Crowther</Link>
            </div>
            <div className="e2-footer-col" data-testid="e2-footer-col-legal">
              <div className="e2-footer-eyebrow">Company</div>
              <Link to="/terms" data-testid="e2-footer-terms">Terms of Service</Link>
              <Link to="/privacy" data-testid="e2-footer-privacy">Privacy Policy</Link>
            </div>
          </div>
        </div>
        <div className="e2-footer-bottom">
          <span>2026 Crowther. All rights reserved.</span>
          <span>Human Insight, Amplified.</span>
        </div>
      </footer>
    </>
  );
}
